export interface User {
  name: string;
  email: string;
  profileImage: string;
  isOwner: boolean;
  isHidden: boolean;
  id: number;
  tfaEnabled: boolean;
  createdTs: number;
  teamId: number;
  clusterId: string;
  teamName: string;
  emailVerified: boolean;
  isEmailVerificationBlock: boolean;
  role?: string;
}

export enum RbacPermissions {
  PIPELINE_EDIT = 'PIPELINE_EDIT',
  PIPELINE_DELETE = 'PIPELINE_DELETE',
  PIPELINE_CREATE = 'PIPELINE_CREATE',

  DESTINATION_EDIT = 'DESTINATION_EDIT',
  DESTINATION_CREATE = 'DESTINATION_CREATE',
  DESTINATION_DELETE = 'DESTINATION_DELETE',

  MODELS_AND_WORKFLOWS_CREATE = 'MODELS_AND_WORKFLOWS_CREATE',
  MODELS_AND_WORKFLOWS_EDIT = 'MODELS_AND_WORKFLOWS_EDIT',
  MODELS_AND_WORKFLOWS_DELETE = 'MODELS_AND_WORKFLOWS_DELETE',

  ACTIVATION_CREATE = 'ACTIVATION_CREATE',
  ACTIVATION_EDIT = 'ACTIVATION_EDIT',
  ACTIVATION_DELETE = 'ACTIVATION_DELETE',

  H2_ACTIVATION_SOURCE_CREATE = 'H2_ACTIVATION_SOURCE_CREATE',
  H2_ACTIVATION_SOURCE_UPDATE = 'H2_ACTIVATION_SOURCE_UPDATE',
  H2_ACTIVATION_SOURCE_DELETE = 'H2_ACTIVATION_SOURCE_DELETE',
  H2_ACTIVATION_APP_CREATE = 'H2_ACTIVATION_APP_CREATE',
  H2_ACTIVATION_APP_UPDATE = 'H2_ACTIVATION_APP_UPDATE',
  H2_ACTIVATION_APP_DELETE = 'H2_ACTIVATION_APP_DELETE',
  H2_ACTIVATION_DATASET_CREATE = 'H2_ACTIVATION_DATASET_CREATE',
  H2_ACTIVATION_DATASET_UPDATE = 'H2_ACTIVATION_DATASET_UPDATE',
  H2_ACTIVATION_DATASET_DELETE = 'H2_ACTIVATION_DATASET_DELETE',
  H2_ACTIVATION_SYNC_CREATE = 'H2_ACTIVATION_SYNC_CREATE',
  H2_ACTIVATION_SYNC_UPDATE = 'H2_ACTIVATION_SYNC_UPDATE',
  H2_ACTIVATION_SYNC_DELETE = 'H2_ACTIVATION_SYNC_DELETE',
  H2_ACTIVATION_SYNC_PAUSE = 'H2_ACTIVATION_SYNC_PAUSE',
  H2_ACTIVATION_SYNC_RUN = 'H2_ACTIVATION_SYNC_RUN',

  TEAM_EDIT = 'TEAM_EDIT',
  TEAM_DELETE = 'TEAM_DELETE',

  BILLING_EDIT = 'BILLING_EDIT',

  H2_RECIPIENT_CREATE = 'H2_RECIPIENT_CREATE',
  H2_RECIPIENT_EDIT = 'H2_RECIPIENT_EDIT',
  H2_RECIPIENT_DELETE = 'H2_RECIPIENT_DELETE',

  H2_TRANSFORMATION_CREATE = 'H2_TRANSFORMATION_CREATE'
}

export const CENTRAL_CLUSTER_ID = 'CENTRAL';

export interface InviteMemberOptions {
  email: string;
  entity: string;
  entity_type: string;
  wizard: string;
  redirect_url: string;
}
